import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import successIconAlert from '../assets/images/success-icon-alert.svg'
import infoIconAlert from '../assets/images/info-icon-alert.svg'
import warningIconAlert from '../assets/images/warning-icon-alert.svg'

export const ALERT_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
}

const ALERT_ICON = {
  [ALERT_TYPE.SUCCESS]: successIconAlert,
  [ALERT_TYPE.WARNING]: warningIconAlert,
  [ALERT_TYPE.INFO]: infoIconAlert,
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-radius: 4px;
  color: #101123;
  padding: 12px;
  width: inherit;

  ${props =>
    props.type === ALERT_TYPE.SUCCESS
      ? `
        border-left: 4px solid #208f61;
        background: #EDF6EC;
        `
      : props.type === ALERT_TYPE.INFO
      ? `
        background: rgba(229, 242, 245, 0.5);
        border-left: 4px solid #005B8E;
        `
      : props.type === ALERT_TYPE.WARNING
      ? `
        background: rgba(170, 71, 0, 0.1);
        border-left: 4px solid #AA4700;
        `
      : ``}
`

const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const Alert = ({ type, children }) => (
  <Container type={type || ALERT_TYPE.INFO}>
    <img src={ALERT_ICON[type || ALERT_TYPE.INFO]} alt="Alert icon" />
    <ChildrenContainer>{children}</ChildrenContainer>
  </Container>
)

Alert.propTypes = {
  type: PropTypes.oneOf([ALERT_TYPE.INFO, ALERT_TYPE.SUCCESS, ALERT_TYPE.WARNING]),
  children: PropTypes.node,
}

export default Alert
